module.exports = __webpack_public_path__ + "media/images/logo-1c3be3d3c64c7dc5d33a11d960c547a7.svg";